import { render, staticRenderFns } from "./CategoryPagination.vue?vue&type=template&id=16b57160&"
import script from "./CategoryPagination.vue?vue&type=script&lang=js&"
export * from "./CategoryPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports